import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { RemoveAlertsRequestModel } from "../RemoveAlertsRequestModel";
import { StudentAlertTableRequest } from "./StudentAlertTableRequest";
import { DynamicValueRequest } from "./DynamicValueRequest";

@Injectable()
export class DataService_Student_Alerts {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DynamicGroupSelectList(AudienceID) {
		var postResult$ = new Subject();
		var url = "Alerts/DynamicGroupSelectList?AudienceID=" + AudienceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictSelectList() {
		var postResult$ = new Subject();
		var url = "Alerts/DistrictSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupSelectList() {
		var postResult$ = new Subject();
		var url = "Alerts/SchoolGroupSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilitySelectList() {
		var postResult$ = new Subject();
		var url = "Alerts/FacilitySelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DynamicValueSelectList(parms: DynamicValueRequest) {
		var postResult$ = new Subject();
		var url = "Alerts/DynamicValueSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentAlertTableSelectList(parms: StudentAlertTableRequest) {
		var postResult$ = new Subject();
		var url = "Alerts/StudentAlertTableSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RemoveAlerts(parms: RemoveAlertsRequestModel) {
		var postResult$ = new Subject();
		var url = "Alerts/RemoveAlerts";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteIncidents(parms: RemoveAlertsRequestModel) {
		var postResult$ = new Subject();
		var url = "Alerts/DeleteIncidents";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertSelectDesc(AlertID) {
		var postResult$ = new Subject();
		var url = "Alerts/AlertSelectDesc?AlertID=" + AlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CurrentYearStartDateSelect() {
		var postResult$ = new Subject();
		var url = "Alerts/CurrentYearStartDateSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
